import {
  TableItemContainer,
  TableItemBody,
} from 'components/Table/Table.styled'
import moment from 'moment'
import React from 'react'
import { AppointmentItemProps } from './Appointments.props'
import { AppointmentItemText } from './Appointments.styled'

const AppointmentsItem = ({ appointment }: AppointmentItemProps) => {

  const date = moment(appointment.date).format('MM/DD/YYYY');
  const startTime = moment(appointment.start_time).format('hh:mm a');
  const endTime = moment(appointment.end_time).format('hh:mm a');
  const time = `${startTime} - ${endTime}`
  const description = appointment.program_id ? 'Program':'Appointment';

  return (
    <TableItemContainer>
      <TableItemBody>
        <AppointmentItemText>
          {date}
        </AppointmentItemText>
      </TableItemBody>
      <TableItemBody>
        <AppointmentItemText>
          {time}
        </AppointmentItemText>
      </TableItemBody>
      <TableItemBody>
        <AppointmentItemText>
          {description}
        </AppointmentItemText>
      </TableItemBody>
      {/* <TableItemBody>
        <AppointmentItemText></AppointmentItemText>
      </TableItemBody> */}
    </TableItemContainer>
  )
}

export default AppointmentsItem
